// import { Container, Grid, Paper } from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import React, { useState, useEffect, useRef } from 'react';
// import { useStateValue } from '../../contexto/store';
// import CerradosGanadosMes from './CerradosGanadosMes';
// import CerradosGanadosMesVendedor from './CerradosGanadosMesVendedor';
// import CerradosPerdidosMes from './CerradosPerdidosMes';
// import CerradosPerdidosMesVendedor from './CerradosPerdidosMesVendedor';
// import GraficoPresupuestosVendedores from './GraficoPresupuestosVendedores';
// import PresupuestosSinProcesarMes from './PresupuestosSinProcesarMes';
// import PresupuestosSinProcesarMesVendedor from './PresupuestosSinProcesarMesVendedor';
// import TopPresupuestosMasAltos from './TopPresupuestosMasAltos';
// import TopPresupuestosVendedor from './TopPresupuestosVendedor';
// import clsx from "clsx";
// import {EvaluarPermiso} from '../Genericos/Generales'

// const useStyles = makeStyles((theme) => ({
//   fixedHeightCard: {
//     height: 180,
//   },
//   paper: {
//     padding: theme.spacing(2),
//     display: "flex",
//     overflow: "auto",
//     flexDirection: "column",
//   },
//   fixedHeight: {
//     height: 650,
//   },
// }));

// // EDUARDO CANDIA
// const MainDashboardPanel = () => {
//   const classes = useStyles();
//   const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
//   const fixedHeightPaperCard = clsx(classes.paper, classes.fixedHeightCard);
//   const mounted = useRef(true);
//   const [{ sesionUsuario }] = useStateValue();

//   const [cerradosGanadoMes, setCerradosGanadoMes] = useState(false);
//   const [cerradosGanadoMesVendedor, setCerradosGanadoMesVendedor] = useState(
//     false
//   );
//   const [cerradosPerdidosMes, setCerradosPerdidosMes] = useState(false);
//   const [
//     cerradosPerdidosMesVendedor,
//     setCerradosPerdidosMesVendedor,
//   ] = useState(false);
//   const [presupuestosSinProcesarMes, setPresupuestosSinProcesarMes] = useState(
//     false
//   );
//   const [
//     presupuestosSinProcesarMesVendedor,
//     setPresupuestosSinProcesarMesVendedor,
//   ] = useState(false);
//   const [
//     graficoPresupuestosVendedores,
//     setGraficoPresupuestosVendedores,
//   ] = useState(false);
//   const [topPresupuestosMasAltos, setTopPresupuestosMasAltos] = useState(false);
//   const [topPresupuestosVendedor, setTopPresupuestosVendedor] = useState(false);

//   useEffect(() => {
//     if (mounted.current) {
//       VerificarPermisos(
//         sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//       );
//     }

//     return function cleanup() {
//       mounted.current = false;
//     };

//   }, 
//   //eslint-disable-next-line
//   [sesionUsuario]);

//   const VerificarPermisos = (arrPermisos) => {
//     //FERNANDO COLUCHI
//     //CATEGORIA
//     setCerradosGanadoMes(
//       EvaluarPermiso(arrPermisos, '/cerradosGanadosMes')
//     );
//     setCerradosGanadoMesVendedor(
//       EvaluarPermiso(arrPermisos, '/cerradosGanadosMesVendedor')
//     );
//     setCerradosPerdidosMes(
//       EvaluarPermiso(arrPermisos, '/cerradosPerdidosMes')
//     );
//     setCerradosPerdidosMesVendedor(
//       EvaluarPermiso(arrPermisos, '/cerradosPerdidosMesVendedor')
//     );
//     setGraficoPresupuestosVendedores(
//       EvaluarPermiso(arrPermisos, '/graficoPresupuestosVendedores')
//     );
//     setPresupuestosSinProcesarMes(
//       EvaluarPermiso(arrPermisos, '/presupuestosSinProcesarMes')
//     );
//     setPresupuestosSinProcesarMesVendedor(
//       EvaluarPermiso(arrPermisos, '/presupuestosSinProcesarMesVendedor')
//     );
//     setTopPresupuestosMasAltos(
//       EvaluarPermiso(arrPermisos, '/topPresupuestosMasAltos')
//     );
//     setTopPresupuestosVendedor(
//       EvaluarPermiso(arrPermisos, '/topPresupuestosVendedor')
//     );
//   };

//   return (
//     <React.Fragment>
//       <br/>
//     <Container maxWidth="lg" component='main'  justify="center" style={{marginTop: 15}}>
//       <Grid container spacing={7} justify="space-around">
//       {cerradosGanadoMes ? (
//         <Grid item xs={12} md={4} lg={4}>
//           <Paper className={fixedHeightPaperCard}>
//             <CerradosGanadosMes />
//           </Paper>
//         </Grid>
//       ) : null}

//       {cerradosGanadoMesVendedor ? (
//         <Grid item xs={12} md={4} lg={4}>
//           <Paper className={fixedHeightPaperCard}>
//             <CerradosGanadosMesVendedor />
//           </Paper>
//         </Grid>
//       ) : null}

//       {cerradosPerdidosMes ? (
//         <Grid item xs={12} md={4} lg={4}>
//           <Paper className={fixedHeightPaperCard}>
//             <CerradosPerdidosMes />
//           </Paper>
//         </Grid>
//       ) : null}

//       {cerradosPerdidosMesVendedor ? (
//         <Grid item xs={12} md={4} lg={4}>
//           <Paper className={fixedHeightPaperCard}>
//             <CerradosPerdidosMesVendedor />
//           </Paper>
//         </Grid>
//       ) : null}

//       {presupuestosSinProcesarMes ? (
//         <Grid item xs={12} md={4} lg={4}>
//           <Paper className={fixedHeightPaperCard}>
//             <PresupuestosSinProcesarMes />
//           </Paper>
//         </Grid>
//       ) : null}
//       <br />
//       <br />

//       {presupuestosSinProcesarMesVendedor ? (
//         <Grid item xs={12} md={4} lg={4}>
//           <Paper className={fixedHeightPaperCard}>
//             <PresupuestosSinProcesarMesVendedor />
//           </Paper>
//         </Grid>
//       ) : null}
//       </Grid>
//       <br />
//       <br />

//       {graficoPresupuestosVendedores ?
//       <Grid item xs={12} md={12} lg={12}>
//       <Paper className={fixedHeightPaper}>
//       <GraficoPresupuestosVendedores /> 
//       </Paper>
//       </Grid>
//       : null}
//       <br />
//       <br />

//       {topPresupuestosMasAltos ? 
//        <Grid item xs={12}>
//        <Paper className={classes.paper}>
//       <TopPresupuestosMasAltos /> 
//       </Paper>
//       </Grid>
//       : null}
//       <br />
//       <br />

//       {topPresupuestosVendedor ? 
//       <Grid item xs={12}>
//       <Paper className={classes.paper}>
//       <TopPresupuestosVendedor />
//       </Paper>
//       </Grid> : null}
//     </Container>
//     </React.Fragment>
//   );
// };

// export default MainDashboardPanel;
import { Container, Grid, Paper, Box } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from '../../contexto/store';
import CerradosGanadosMes from './CerradosGanadosMes';
import CerradosGanadosMesVendedor from './CerradosGanadosMesVendedor';
import CerradosPerdidosMes from './CerradosPerdidosMes';
import CerradosPerdidosMesVendedor from './CerradosPerdidosMesVendedor';
import GraficoPresupuestosVendedores from './GraficoPresupuestosVendedores';
import PresupuestosSinProcesarMes from './PresupuestosSinProcesarMes';
import PresupuestosSinProcesarMesVendedor from './PresupuestosSinProcesarMesVendedor';
import TopPresupuestosMasAltos from './TopPresupuestosMasAltos';
import TopPresupuestosVendedor from './TopPresupuestosVendedor';
import { EvaluarPermiso } from '../Genericos/Generales';

// Estilos modernos con sx prop
const cardStyles = {
  height: 200,
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 2,
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  transition: 'all 0.3s ease',
  border: '1px solid',
  borderColor: 'divider',
  '&:hover': {
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    transform: 'translateY(-4px)',
  },
};

const chartPaperStyles = {
  height: 650,
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 3,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
};

const tablePaperStyles = {
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 3,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
};

const MainDashboardPanel = () => {
  const mounted = useRef(true);
  const [{ sesionUsuario }] = useStateValue();

  const [cerradosGanadoMes, setCerradosGanadoMes] = useState(false);
  const [cerradosGanadoMesVendedor, setCerradosGanadoMesVendedor] = useState(
    false
  );
  const [cerradosPerdidosMes, setCerradosPerdidosMes] = useState(false);
  const [
    cerradosPerdidosMesVendedor,
    setCerradosPerdidosMesVendedor,
  ] = useState(false);
  const [presupuestosSinProcesarMes, setPresupuestosSinProcesarMes] = useState(
    false
  );
  const [
    presupuestosSinProcesarMesVendedor,
    setPresupuestosSinProcesarMesVendedor,
  ] = useState(false);
  const [
    graficoPresupuestosVendedores,
    setGraficoPresupuestosVendedores,
  ] = useState(false);
  const [topPresupuestosMasAltos, setTopPresupuestosMasAltos] = useState(false);
  const [topPresupuestosVendedor, setTopPresupuestosVendedor] = useState(false);

  useEffect(() => {
    if (mounted.current && sesionUsuario?.usuario?.pantallasUsuario) {
      VerificarPermisos(sesionUsuario.usuario.pantallasUsuario.listaPantallasRol);
    }

    return () => {
      mounted.current = false;
    };
  }, [sesionUsuario]);

  const VerificarPermisos = (arrPermisos) => {
    setCerradosGanadoMes(EvaluarPermiso(arrPermisos, '/cerradosGanadosMes'));
    setCerradosGanadoMesVendedor(EvaluarPermiso(arrPermisos, '/cerradosGanadosMesVendedor'));
    setCerradosPerdidosMes(EvaluarPermiso(arrPermisos, '/cerradosPerdidosMes'));
    setCerradosPerdidosMesVendedor(EvaluarPermiso(arrPermisos, '/cerradosPerdidosMesVendedor'));
    setGraficoPresupuestosVendedores(EvaluarPermiso(arrPermisos, '/graficoPresupuestosVendedores'));
    setPresupuestosSinProcesarMes(EvaluarPermiso(arrPermisos, '/presupuestosSinProcesarMes'));
    setPresupuestosSinProcesarMesVendedor(EvaluarPermiso(arrPermisos, '/presupuestosSinProcesarMesVendedor'));
    setTopPresupuestosMasAltos(EvaluarPermiso(arrPermisos, '/topPresupuestosMasAltos'));
    setTopPresupuestosVendedor(EvaluarPermiso(arrPermisos, '/topPresupuestosVendedor'));
  };

  return (
    <Box sx={{ flexGrow: 1, py: 4, backgroundColor: '#fafafa', minHeight: '100vh' }}>
      <Container maxWidth="xl">
        <Grid container spacing={3} sx={{ maxWidth: 1400, margin: '0 auto' }}>
          {cerradosGanadoMes && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper sx={cardStyles}>
                <CerradosGanadosMes />
              </Paper>
            </Grid>
          )}

          {cerradosPerdidosMes && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper sx={cardStyles}>
                <CerradosPerdidosMes />
              </Paper>
            </Grid>
          )}

          {cerradosGanadoMesVendedor && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper sx={cardStyles}>
                <CerradosGanadosMesVendedor />
              </Paper>
            </Grid>
          )}

          {cerradosPerdidosMesVendedor && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper sx={cardStyles}>
                <CerradosPerdidosMesVendedor />
              </Paper>
            </Grid>
          )}

          {presupuestosSinProcesarMes && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper sx={cardStyles}>
                <PresupuestosSinProcesarMes />
              </Paper>
            </Grid>
          )}

          {presupuestosSinProcesarMesVendedor && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper sx={cardStyles}>
                <PresupuestosSinProcesarMesVendedor />
              </Paper>
            </Grid>
          )}
        </Grid>

        {graficoPresupuestosVendedores && (
          <Box sx={{ mt: 4, maxWidth: 1400, margin: '32px auto 0' }}>
            <Paper sx={chartPaperStyles}>
              <GraficoPresupuestosVendedores />
            </Paper>
          </Box>
        )}

        {topPresupuestosMasAltos && (
          <Box sx={{ mt: 4, maxWidth: 1400, margin: '32px auto 0' }}>
            <Paper sx={tablePaperStyles}>
              <TopPresupuestosMasAltos />
            </Paper>
          </Box>
        )}

        {topPresupuestosVendedor && (
          <Box sx={{ mt: 4, maxWidth: 1400, margin: '32px auto 0' }}>
            <Paper sx={tablePaperStyles}>
              <TopPresupuestosVendedor />
            </Paper>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default MainDashboardPanel;